<div
  class="modal fade"
  #historyModal
  tabindex="-1"
  aria-labelledby="historyModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5
          class="modal-title d-flex align-items-center gap-2"
          id="historyModalLabel"
        >
          <i class="bi bi-chat-left-text"></i> Assistant Chat
        </h5>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="onCloseClicked()"
        >
          ✖
        </button>
      </div>
      <div class="modal-body">
        <app-application-summary-card
          *ngIf="showApplicationDetails"
          [applicationId]="applicationId"
        ></app-application-summary-card>

        <div class="message-list">
          <div
            *ngFor="let history of conversationHistory"
            class="message-container"
            [ngClass]="{
              left: history.message_type !== 'from_assistant',
              right: history.message_type === 'from_user'
            }"
            [hidden]="history.message_type === 'Prompt' && !showPrompts"
          >
            <app-chat-bubble
              [type]="history.message_type"
              [date]="history.updated_at"
              [content]="history.message_text"
            ></app-chat-bubble>
          </div>
        </div>

        <div class="modal-tools">
          <button type="button" class="toggle-icon" (click)="togglePrompts()">
            <i [ngClass]="showPrompts ? 'bi-toggle-on' : 'bi-toggle-off'"></i>
          </button>

          <button
            type="button"
            class="toggle-icon"
            (click)="toggleApplicationDetails()"
          >
            <i
              [ngClass]="showApplicationDetails ? 'bi-x-lg' : 'bi-person-vcard'"
            ></i>
          </button>
        </div>

        <app-chat-input
          [applicationId]="applicationId"
          (messageSent)="onMessageSent($event)"
          (applicationCreated)="onApplicationCreated($event)"
        ></app-chat-input>
      </div>
    </div>
  </div>
</div>
